export default __webpack_public_path__ + "static/astronaut-d181897b997515ea471a44c4bbc98dab.png";